import { getEnvelope, getPropertyInfo, trackHotpadsEvent } from '../track';
import type { HotpadsClickstreamListing } from '../types';

export type ReviewsProvider = 'web' | 'google' | 'reddit';
export type ReviewsInteraction =
  | { event: 'reviews_module_impression'; availableProviders: Array<ReviewsProvider>; provider: ReviewsProvider }
  | { event: 'reviews_entry_click'; availableProviders: Array<ReviewsProvider> }
  | { event: 'reviews_provider_change'; provider: ReviewsProvider; previousProvider: ReviewsProvider }
  | {
      event: 'reviews_category_navigation';
      provider: 'web';
      direction: 'next' | 'previous';
      inputMethod: 'arrow' | 'scroll';
      categoryIds: Array<string>;
    }
  | {
      event: 'reviews_summary_toggle';
      provider: 'web';
      categoryId: string;
      expanded: boolean;
      surface: 'carousel' | 'sheet';
    }
  | { event: 'reviews_categories_open'; provider: 'web' }
  | { event: 'reviews_reddit_topic_click'; provider: 'reddit'; topicId: string };

type Registration = {
  eventId: string;
  source: string;
};

export const reviewsEventRegistrations: Record<ReviewsInteraction['event'], Registration> = {
  reviews_module_impression: { eventId: '10453', source: 'reviews_module' },
  reviews_entry_click: { eventId: '10454', source: 'reviews_entry_link' },
  reviews_provider_change: { eventId: '10455', source: 'reviews_provider_tabs' },
  reviews_category_navigation: { eventId: '10457', source: 'reviews_category_carousel' },
  reviews_summary_toggle: { eventId: '10458', source: 'reviews_summary_toggle' },
  reviews_categories_open: { eventId: '10459', source: 'reviews_categories_link' },
  reviews_reddit_topic_click: { eventId: '10460', source: 'reviews_reddit_topic_link' },
};

export function emitReviewsEvent(listing: HotpadsClickstreamListing | null, interaction: ReviewsInteraction): void {
  const registration = reviewsEventRegistrations[interaction.event];
  if (!listing) return;
  const { event } = interaction;
  const payload = {
    envelope: getEnvelope({ eventId: registration.eventId, eventVersion: '1', templateId: '4', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: event === 'reviews_module_impression' ? 'impression' : 'interaction',
      trigger_location_nm: 'home_details',
      trigger_source_nm: registration.source,
      trigger_object_nm:
        interaction.event === 'reviews_summary_toggle'
          ? interaction.surface === 'carousel'
            ? 'reviews_category_carousel'
            : 'reviews_categories_sheet'
          : 'no_trigger_object',
    },
    semantic: { semantic_event_nm: event === 'reviews_module_impression' ? 'view_content' : event, topic_tag_txt: [] },
    ...getPropertyInfo({ ...listing, units: undefined }),
  };
  trackHotpadsEvent(payload);
}
